import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { getApps, initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

if (isFirebaseConfigured() && !getApps().length) {
  const firebaseApp = initializeApp(environment.firebaseConfig);
  initializeFirestore(firebaseApp, {
    experimentalForceLongPolling: true,
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
  ],
}).catch((error) => console.error(error));

function isFirebaseConfigured(): boolean {
  const config = environment.firebaseConfig;

  return Boolean(config.apiKey && config.authDomain && config.projectId && config.appId);
}
